var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPencil(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4401 3.77981L2.19808 14.0198C1.89356 14.3242 1.6954 14.7188 1.63308 15.1448L1.08008 18.9188L4.85508 18.3658C5.28124 18.3032 5.67581 18.1047 5.98008 17.7998L16.2201 7.55981M12.4401 3.77981L14.6691 1.54981C14.8177 1.4012 14.9941 1.28331 15.1882 1.20288C15.3823 1.12245 15.5904 1.08105 15.8006 1.08105C16.0107 1.08105 16.2188 1.12245 16.413 1.20288C16.6071 1.28331 16.7835 1.4012 16.9321 1.54981L18.4501 3.06781C18.5987 3.21639 18.7166 3.39279 18.797 3.58694C18.8774 3.78108 18.9188 3.98917 18.9188 4.19931C18.9188 4.40946 18.8774 4.61755 18.797 4.81169C18.7166 5.00584 18.5987 5.18223 18.4501 5.33081L16.2201 7.55981M12.4401 3.77981L16.2201 7.55981",
    stroke: "#302D1A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/pencil.3f6c187f07dcb54d7b3126bbf9b2e715.svg";
export { ForwardRef as ReactComponent };